export default "__VITE_ASSET__CDdpq1T9__"